import {z} from 'zod';
import {
	editRemovesFromFilter,
	type EditRemovesFromFilterParams,
	getDefaultFilters,
	type GetDefaultFiltersParams,
	makeOptionalPropsNullable,
} from '@netx/core-next/schema';
import {
	UserIntegrationField,
	type IUserIntegration,
	UserIntegrationSchema,
} from './userIntegrationSchema';

export const UserIntegrationFilterSchema = makeOptionalPropsNullable(
	UserIntegrationSchema.partial().pick({
		[UserIntegrationField.name]: true,
		[UserIntegrationField.modDate]: true,
		[UserIntegrationField.creationDate]: true,
		[UserIntegrationField.actionSummaries]: true,
	}),
);

export const UserIntegrationFilterableField =
	UserIntegrationFilterSchema.keyof().enum;

export const USER_INTEGRATION_FILTERABLE_FIELDS = Object.values(
	UserIntegrationFilterableField,
);

export type UserIntegrationFilter = z.infer<typeof UserIntegrationFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getUserIntegrationDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<UserIntegrationFilter>,
		'filterableFields'
	>,
): UserIntegrationFilter =>
	getDefaultFilters({
		...params,
		filterableFields: USER_INTEGRATION_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const cacheEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<IUserIntegration, UserIntegrationFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: UserIntegrationSchema,
	});
